<template>
  <div :class="$style.container">
    <base-icon
      v-color="type === 'star' ? 'yellow' : 'red'"
      :name="`basic_${type}-filled`"
      :size="16"
    />
    <span
      v-m-l="5"
      v-text="displayGrade"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'TransactionRating',
  props: {
    rating: {
      type: Object,
      required: true,
    },
    maxGrade: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    grade() {
      return this.rating.rating;
    },
    type() {
      return this.rating.type;
    },
    displayGrade() {
      return `${this.grade}/${this.maxGrade}`;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +font-type('medium', 14, 18)
    color: inherit
</style>
